import { z } from 'zod'

export const memberSidebarOpenedSchema = z.object({
  masterTaskId: z.string(),
})
